<template>
	<div>
		<div class="box">
			<img src="../assets/banner.jpg" alt="">
			<div class="head">
				<div class="con fcs">
					<img class="logo" src="../assets/logo1.png" alt="">
					<div class="login fc">
						<div class="search fcs">
							<img src="../assets/search.png" alt="" style="width: 23px;margin-left: 9px;">
							<input type="text" placeholder="请输入搜索内容"
								style="width: 240px;height: 32px;outline: none;border: 0;" />
							<div class="btn fcc" @click="changenav('/search')">搜一下</div>
						</div>
						<div class="fc" v-if="userinfo == null">
							<div @click="changenav('/login')">登录</div>
							<div style="margin: 0 8px;">|</div>
							<div @click="changenav('/register')">注册</div>
						</div>
						<div class="fc" v-else>
							<div>{{userinfo.nickname}}</div>
							<div style="margin: 0 8px;">|</div>
							<div @click="tuichu">退出登录</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="tabbox">
			<div class="con fcs">
				<div :class="path == '/'?'tab-a fcc':'tab fcc'" @click="changenav('/')">
					<img src="../assets/nav1.png" alt="">
					<div>平台首页</div>
				</div>
				<div :class="path == '/news1'?'tab-a fcc':'tab fcc'" @click="changenav('/news1')">
					<img src="../assets/nav2.png" alt="">
					<div>招标公告</div>
				</div>
				<div :class="path == '/news2'?'tab-a fcc':'tab fcc'" @click="changenav('/news2')">
					<img src="../assets/nav3.png" alt="">
					<div>公示公告</div>
				</div>
				<div :class="path == '/news3'?'tab-a fcc':'tab fcc'" @click="changenav('/news3')">
					<img src="../assets/nav4.png" alt="">
					<div>办事指南</div>
				</div>
				<div :class="path == '/about'?'tab-a fcc':'tab fcc'" @click="gopage('https://www.zjjljs.cn/')">
					<img src="../assets/nav5.png" alt="">
					<div>联系我们</div>
				</div>
				<div :class="path == '/userinfo'?'tab-a fcc':'tab fcc'" @click="gouserinfo">
					<img src="../assets/nav5.png" alt="">
					<div>个人中心</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Header',
		props: {},
		data() {
			return {
				userinfo: null,
				path: '/',
				activeName: 'login',
				outerVisible: false,
				loginform: {
					account: '', //账号
					password: '', //密码
					corporate_name: '' //公司名称
				},
				registerform: {
					name: '', //姓名
					mobile: '', //手机号
					code: '', //验证码
					password: '', //密码
					corporate_name: '', //公司名称
					business_license: '' //营业执照
				},
				forgetform: {
					mobile: '', //手机号
					captcha: '', //验证码
					newpassword: '' //新密码
				}
			}
		},
		created() {
			this.changeroute();
		},
		watch: {
			$route(to, from) {
				this.changeroute();
				if (sessionStorage.getItem('user_info')) {
					this.userinfo = JSON.parse(sessionStorage.getItem('user_info'));
				} else {
					this.userinfo = null;
				}
			}
		},
		methods: {
			//切换导航
			changenav(path) {
				this.path = path;
				this.$router.push({
					path: path
				})
				sessionStorage.setItem('pagepath', path)
			},
			gouserinfo() {
				if (!sessionStorage.getItem('token')) {
					alert('请先登录')
					return;
				}
				this.changenav('/userinfo')
			},
			changeroute() {
				let pagepath = sessionStorage.getItem('pagepath')
				if (pagepath) {
					this.path = pagepath
				} else {
					this.path = '/'
				}
			},
			gopage(url) {
				window.open(url, "_blank");
			},
			//退出登录
			tuichu() {
				let that = this;
				that.$confirm('确定退出登录吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					sessionStorage.removeItem('token');
					sessionStorage.removeItem('user_info');
					that.userinfo = null;
				}).catch(() => {});
			}
		}
	}
</script>

<style scoped>
	.box {
		width: 100%;
		position: relative;
	}

	.box img {
		width: 100%;
		display: block;
	}

	.box .head {
		width: 100%;
		position: absolute;
		top: 39px;
		left: 0;
	}

	.box .head .con {
		width: 1200px;
		margin: 0 auto;
		color: #0057A8;
		font-size: 16px;
		opacity: 0.9;
	}

	.box .head .con .logo {
		width: 400px;
	}

	.box .head .con .login {
		cursor: pointer;
	}

	.box .head .con .search {
		width: 374px;
		height: 35px;
		background: #FFFFFF;
		border: 1px solid #DBDBDB;
		border-radius: 17px;
		margin-right: 29px;
	}

	.box .head .con .search .btn {
		width: 94px;
		height: 35px;
		background: #0057A8;
		border-radius: 17px;
		font-size: 14px;
		color: #ffffff;
	}

	.tabbox {
		width: 100%;
		height: 54px;
		background: #0B457A;
	}

	.tabbox .con {
		width: 1200px;
		height: 54px;
		margin: 0 auto;
	}

	.tabbox .con .tab {
		width: 204px;
		height: 54px;
		font-size: 18px;
		margin-right: 20px;
		color: #ffffff;
		cursor: pointer;
	}

	.tabbox .con .tab:hover {
		background: #1872C2;
	}

	.tabbox .con .tab-a {
		width: 204px;
		height: 54px;
		font-size: 18px;
		margin-right: 20px;
		color: #ffffff;
		background: #1872C2;
		cursor: pointer;
	}

	.tabbox .con .tab img {
		width: 22px;
		margin-right: 12px;
	}

	.tabbox .con .tab-a img {
		width: 22px;
		margin-right: 12px;
	}

	.inputbox {
		width: 340px;
		margin: 0 auto;
		margin-top: 20px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>